import React, {useEffect} from 'react';
import Layout from "@/locales/en/layout/Layout";
import {useTranslation} from "react-i18next";
import CustomTitle from "@/components/custom_title";

function Magistratura3(props) {

    const {t} = useTranslation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    document.title=t("header.header__sub__menu.menu-9.item-3")

    return (
        <Layout>
            <CustomTitle name={t("header.header__sub__menu.menu-9.item-3")}/>

            <div className="container">
                <table width="1346" className="table table-bordered">
                    <tbody>
                    <tr>
                        <td colSpan="4" width="1346">
                            <p><strong>MASTER&rsquo;S EDUCATIONAL PROGRAM МА 70710601-Power Supply (Industrial
                                Enterprises and Cities)</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Educational objectives of the EP</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p>&nbsp;</p>
                            <p>Training of highly qualified specialists for scientific and pedagogical activity in all
                                educational institutions, in the Academy of Sciences of the Republic of Uzbekistan and
                                sectorial research institutes, in educational institutions for retraining and advanced
                                training, in technological and design scientific and production institutions, as well as
                                production enterprises engaged in the design, manufacture, assembly, adjustment and
                                operation of power supply systems.</p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>The objects of professional activity of masters in EP MA 70710601 - Energy supply
                                (industrial enterprises and cities) are:</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p>&nbsp;</p>
                            <p>-higher education, retraining and advanced training, professional, pedagogical activity
                                in professional educational institutions;</p>
                            <p>-research activities and processes in the Academy of Sciences and sectoral research
                                institutes and centres, as well as in higher education institutions;</p>
                            <p>- retraining and advanced training institutions of the education system;</p>
                            <p>- public administration and its various territorial subdivisions;</p>
                            <p>- processes of production, transformation, transmission, distribution and consumption of
                                electric energy;</p>
                            <p>- consumers of electric energy;</p>
                            <p>- equipment used in the power supply system and their designs;</p>
                            <p>- electrical equipment of power supply systems of industrial enterprises and cities;</p>
                            <p>- relay protection and automation devices of power supply systems;</p>
                            <p>- area of specialisation of technological and design scientific and production
                                institutions.</p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Requirements for the professional competence of Master's students in the
                                educational program MA 70710601 - Power Supply (Industrial Enterprises and
                                Cities)</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p>&nbsp;</p>
                            <p>- to acquire skills in carrying out scientific, applied research, processing results of
                                experiments and making on their basis scientifically grounded conclusions, preparing and
                                editing scientific articles, organisation, carrying out scientific seminars, conferences
                                and symposiums, developing scientific projects;</p>
                            <p>- to know the use of information and pedagogical technologies in pedagogical
                                activity;</p>
                            <p>- to know the innovative approach to improving the quality and efficiency of
                                education;</p>
                            <p>- to have skills in project preparation for participation in projects published in the
                                republic and abroad on the results of scientific activity;</p>
                            <p>- to have skills in project preparation for participation in projects announced by
                                republican, non-governmental and non-commercial organisations;</p>
                            <p>- to have skills in organisation and management of production;</p>
                            <p>&nbsp;- to possess skills in carrying out tests on a determination of working parameters
                                of devices of power supply systems of industrial enterprises and cities;</p>
                            <p>- to acquire skills in performing, normalising and mastering the processes of the power
                                supply system of industrial enterprises and cities;</p>
                            <p>- to be able to control observance of technological discipline at designing of electric
                                power supply of industrial enterprises and cities;</p>
                            <p>- to know modern methods of designing power supply, power supply of industrial
                                enterprises and cities;</p>
                            <p>- to be able to develop and implement measures for rational use of energy resources in
                                the system of power supply of industrial enterprises and cities;</p>
                            <p>- to possess skills in planning resources necessary for the maintenance of continuity of
                                consumers in the system of power supply of industrial enterprises and cities;</p>
                            <p>- to have skills in the inspection of power plant equipment, technical condition of
                                structures and equipment and assessment of residual resources of the power supply system
                                of industrial enterprises and cities.</p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Professional duties of Master's educational program MA 70710601 - Power Supply
                                (Industrial Enterprises and Cities)</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p><strong>In research and teaching activities:</strong></p>
                            <p>- conducting scientific, applied research, analysing the results of experiments and
                                drawing scientifically justified conclusions on their basis, discovering scientific
                                innovations;</p>
                            <p>- preparation and editing of scientific articles, lectures, brochures, and educational
                                literature, development of scientific reviews on the topic of research, the practice of
                                abstracts and bibliographies;</p>
                            <p>- purposeful search and search for information on the latest scientific, design,
                                technological and operational achievements in scientific literature and the
                                Internet;</p>
                            <p>- organisation, holding and active participation in scientific seminars, conferences and
                                symposiums;</p>
                            <p>- development of scientific projects on the topic of the relevant speciality, development
                                of conceptual and theoretical models of solved scientific problems and tasks;</p>
                            <p>- implementation of pedagogical and teaching, and methodological activities in the
                                specialities of higher education, retraining and advanced training in professional
                                educational institutions;</p>
                            <p>- organisation of the educational process and scientific activity, conducting training
                                sessions using modern information and pedagogical technologies, technical means of
                                training;</p>
                            <p>- perfect mastery of electronic (e-learning), mobile (m-learning), distance information
                                technologies and teaching and learning complexes;</p>
                            <p>- systematic improvement of pedagogical and scientific skills and qualifications.</p>
                            <p><strong>&nbsp;In design and engineering activities:</strong></p>
                            <p>&nbsp; - designing of power supply of industrial enterprises and cities;</p>
                            <p>-to study, analysis, development and application of design and construction works of
                                industrial enterprises and cities;</p>
                            <p>-to study, analysis, development and application of design and technological works at
                                industrial enterprises;</p>
                            <p>-to have skills and qualifications for the full performance of design and engineering and
                                design-technological works on the design of power supply of industrial enterprises and
                                cities;</p>
                            <p>-to have experience in performance and application of design and engineering works on
                                designing of power supply of industrial enterprises and cities both in research
                                institutes and in organisations;</p>
                            <p>-to have skills and experience in performing design and engineering works on the design
                                of power supply of industrial enterprises and cities using modern information and
                                digital technologies in light of the requirements.</p>
                            <p><strong>In analytical and control activities:</strong></p>
                            <p>- Knowledge of laws and normative legal acts of the Republic of Uzbekistan on electricity
                                supply and rational use of electric energy by the state, local authorities and economic
                                entities and using them in their activities;</p>
                            <p>- development of conceptual and theoretical models of solved scientific problems and
                                tasks in the field of designing power supply of industrial enterprises and cities and
                                introduction into practice of recommendations and developments on results of research
                                works;</p>
                            <p>- improvement of the quality of works on designing of power supply of industrial
                                enterprises and cities and development of ways of its development;</p>
                            <p>- analysis and comparison of indicators characterising processes and phenomena related to
                                the design of power supply of domestic and foreign industrial enterprises and
                                cities.</p>
                            <p><strong>In organisational, managerial and production-service activities:</strong></p>
                            <p>- development of methods and mechanisms for monitoring and assessing the quality of
                                production processes using modern information technologies;</p>
                            <p>- organising the work of a team of performers;</p>
                            <p>- drawing up a plan of the work to be performed and controlling this work, planning the
                                resources required to perform the work, evaluating the results of one's work;</p>
                            <p>- monitoring compliance of production processes with environmental, fire, technical and
                                labour safety requirements;</p>
                            <p>- compliance with the rules of professional ethics.</p>
                            <p><strong>In production and service activities:</strong></p>
                            <p>- effective operation of objects, processes, systems, equipment and technical means of
                                the power supply system of industrial enterprises and cities;</p>
                            <p>- participation in the team of performers in the development of systems, technological
                                processes, their elements and technological documentation;</p>
                            <p>- ensuring the operational safety of facilities, processes, systems, equipment and
                                technical means of power supply systems of industrial enterprises and cities;</p>
                            <p>- development of technological solutions for the organisation and improvement of
                                production;</p>
                            <p>- technical and economic analysis;</p>
                            <p>- selection and application of effective methods of production organisation;</p>
                            <p>- development of an analytical review of the current situation on the operation of
                                devices and equipment of power supply systems of industrial enterprises and cities;</p>
                            <p>- participation in expert groups for the examination of projects on the topics
                                corresponding to the educational program of Power Supply (Industrial Enterprises And
                                Cities);</p>
                            <p>- organisation and implementation of paid educational services;</p>
                            <p>- provision of various services on the subject corresponding to the specialisation.</p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Curriculum for master&rsquo;s EP MA 70710601- Power Supply </strong></p>
                            <p><strong>(Industrial Enterprises and Cities)</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p>
                                <strong>
                                    <a style={{color: 'blue'}}
                                       href="https://test.tdtu.uz/storage/pages/October2024/BzBg2HE0Y3c1DvL37COP.pdf">
                                        Curriculum for master’s of Educational program MA 70710601 - Power Supply
                                        (Industrial
                                        Enterprises and Cities)
                                    </a>
                                </strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Learning Outcome Matrix &ndash;Modules to EP MA 70710601 - Power Supply
                                (Industrial Enterprises and Cities)</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p><strong>
                                <a href="http://test.tdtu.uz/storage/pages/October2024/m1mgcM7OLdAQxEtGAgoa.pdf"
                                   style={{color: "blue"}}>
                                    Learning Outcome Matrix –Modules to EP MA 70710601 - Power Supply (Industrial
                                    Enterprises and Cities)
                                </a>
                            </strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan="2" width="212">
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>Module </strong></p>
                            <p><strong>Handbooks</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                        <td width="461">
                            <p><strong>Mandatory</strong> <strong>module</strong></p>
                        </td>
                        <td width="413">
                            <p><strong>Choice module</strong></p>
                        </td>
                        <td width="260">
                            <p><strong>Scientific activity</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="400">
                            <p><strong>Handbooks</strong></p>
                            <strong>
                                <ul style={{listStyle: "none"}}>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/vwMw5wleaOiYicTMGA3H.pdf"
                                        >
                                            SCIENTIFIC RESEARCH METHODOLOGY
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/kw5vNeqSVwJ12y7AzwDD.pdf"
                                        >
                                            INTELLECTUAL POWER SUPPLY SYSTEMS
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/hYHnp3sxpiv2d6QvXtgT.pdf"
                                        >
                                            RELAY PROTECTION AND AUTOMATION OF THE POWER
                                            SUPPLY SYSTEM
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/zMdTr0N7gPMdM39dftPa.pdf"
                                        >
                                            REACTIVE POWER COMPENSATION
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/l59xTB3WwRRZhEbLaon8.pdf"
                                        >
                                            ENERGY AUDIT METHODS AND EQUIPMENT
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/KRi3y8Hh5AQYns1x3haZ.pdf"
                                        >
                                            QUALITY INDICATORS OF ELECTRICAL ENERGY
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/IIzgyfIwMGPcobEhQG8l.pdf"
                                        >
                                            METHODS OF CALCULATING ELECTRICAL LOADS FOR
                                            INDUSTRIAL ENTERPRISES AND URBAN CONSUMERS
                                        </a>
                                    </li>
                                </ul>
                            </strong>
                        </td>
                        <td width="413">
                            <p><strong>Handbooks</strong></p>
                            <strong>
                                <ul style={{listStyle: "none"}}>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/kZuvhJcYcy63DXzqmw15.pdf"
                                        >
                                            ENERGY EFFICIENCY IN THE ELECTRIC POWER SUPPLY
                                            SYSTEM
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/8ZNx9t45GturC6tbUK0l.pdf"
                                        >
                                            RATIONAL USE OF ENERGY AND REGULATION OF
                                            ELECTRICITY CONSUMPTION
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/Sp66tFSBAJ9L8aPAC6vA.pdf"
                                        >
                                            REVERSE ENGINEERING
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/IZB8dUNCQQjftjCxyjsZ.pdf"
                                        >
                                            THEORY OF AUTOMATIC CONTROL AND REGULATION
                                        </a>
                                    </li>
                                </ul>
                            </strong>
                        </td>
                        <td width="320">
                            <p><strong>Handbooks</strong></p>
                            <strong>
                                <ul style={{listStyle: "none"}}>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/CLZTVfGXIMnz3V37u301.pdf"
                                        >
                                            70710601 – Power supply (industrial enterprises and cities) and
                                            70710407 – Power supply master's specialty "Preparation and
                                            defense of scientific research work and master's thesis" and
                                            "Scientific pedagogical work"
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/1lHmKDOMcMQ3mXTAUnNA.pdf"
                                        >
                                            70710601 - Power Supply (Industrial Enterprises and Cities) specialty
                                            It is designed for the 2nd year master's students of the "Electrical supply"
                                            department
                                        </a>
                                    </li>
                                </ul>
                            </strong>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Layout>
    );
}

export default Magistratura3;